import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        goodsvaluearr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_GOODSVALUELIST: (state, obj) => {

            state.total = obj.total
            state.goodsvaluearr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.goodsvaluearr.splice(index,1)
        },
        CLEAR_GOODSVALUELIST: (state) => {

            state.total = 0
            state.goodsvaluearr=[]

        },


    },
    actions: {
        async getGoodsvaluelist({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getgoodsvaluelist(params)
            if (code == 200) {
                commit('SET_GOODSVALUELIST', data);
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}